<div class="width-container countdown-clock-container">

<p class="countdown-clock-header" [innerText]="'COUNTDOWN_CLOCK.DESC' | translate"></p>
<div class="countdown-clock" tabindex="0">
    <div>
        <p>{{days}}</p>
        <p>
            <span [innerText]="'COUNTDOWN_CLOCK.DAYS' | translate"></span>
            @if(days != 1){
            <span [innerText]="'COUNTDOWN_CLOCK.LETTER_S' | translate"></span>
            }

        </p>
    </div>
    <div>
        <p>{{hours}}</p>
        <p>
            <span [innerText]="'COUNTDOWN_CLOCK.HOURS' | translate"></span>
            @if(hours != 1){
            <span [innerText]="'COUNTDOWN_CLOCK.LETTER_S' | translate"></span>
            }
        </p>
    </div>
    <div>
        <p>{{minutes}}</p>
        <p>
            <span [innerText]="'COUNTDOWN_CLOCK.MINUTES' | translate"></span>
            @if(minutes != 1){
            <span [innerText]="'COUNTDOWN_CLOCK.LETTER_S' | translate"></span>
            }
        </p>
    </div>
    <div>
        <p>{{seconds}}</p>
        <p>
            <span [innerText]="'COUNTDOWN_CLOCK.SECONDS' | translate"></span>
            @if(seconds != 1){
            <span [innerText]="'COUNTDOWN_CLOCK.LETTER_S' | translate"></span>
            }
        </p>
    </div>
</div>
</div>